import type { KnowledgeScopeOption, ToneLevelOption } from '../api'
import type { NormalizedLanguageModeOption } from './chatPreferences'

export type BaseSettings = {
  language_mode: NormalizedLanguageModeOption
  knowledge_scope: KnowledgeScopeOption
  tone_level: ToneLevelOption
}

export const DEFAULT_SETTINGS: BaseSettings = {
  language_mode: 'modern',
  knowledge_scope: 'bounded',
  tone_level: 'adult',
}
